import {
  getCareSourceOriginalText,
  getCareSourceTitle,
} from './careSourceStatusModel';

const normalizeDuplicateText = (value = '') => (
  String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
);

export const buildCareSourceDuplicateKey = (source = {}) => {
  const fingerprint = normalizeDuplicateText(source.sourceFingerprint);
  if (fingerprint) return `fingerprint:${fingerprint}`;

  const sourceText = normalizeDuplicateText(getCareSourceOriginalText(source));
  if (!sourceText) return '';

  return [
    'text',
    normalizeDuplicateText(source.sourceContext || source.sourceMetadata?.sourceContext),
    normalizeDuplicateText(getCareSourceTitle(source)),
    sourceText,
  ].join(':');
};

export const collapseDuplicateCareSources = (sources = []) => {
  const sourcesByDuplicateKey = new Map();
  const uniqueSources = [];
  let hiddenDuplicateCount = 0;

  sources.forEach((source) => {
    const duplicateKey = buildCareSourceDuplicateKey(source);
    if (!duplicateKey) {
      uniqueSources.push(source);
      return;
    }

    const existingSource = sourcesByDuplicateKey.get(duplicateKey);
    if (!existingSource) {
      const nextSource = {
        ...source,
        duplicateSourceCount: 0,
        duplicateSourceIds: [],
      };
      sourcesByDuplicateKey.set(duplicateKey, nextSource);
      uniqueSources.push(nextSource);
      return;
    }

    existingSource.duplicateSourceCount += 1;
    existingSource.duplicateSourceIds.push(source.id);
    hiddenDuplicateCount += 1;
  });

  return {
    hiddenDuplicateCount,
    sources: uniqueSources,
  };
};
